import { makeStyles } from '@material-ui/core/styles';

import image from '../../assets/images/petrochemical-plant_0.jpg';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${image})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  logo: {
    height: '80px',
    marginBottom: '50px',
  },
  descriptionContainer: {
    marginBottom: '20px',
  },
  description: {
    marginTop: '15px',
  },
}));
